import KreditPages from "../components/KreditPages";
import fetch from "../utils/fetch";

const kreditLaptop = ({ query, asPath, item }) => {
  return (
    <KreditPages
      query={query}
      asPath={asPath}
      item={item}
    ></KreditPages>
  );
};

kreditLaptop.getInitialProps = async ({ res, query, asPath }) => {
  const listOfflineShop = await fetch("GET", `/static/offlineShop`, {}, true);

  if (listOfflineShop.status === 200) {
    const item = await listOfflineShop.data.data.find(
      ({ key }) => key === `kredit-laptop`
    );

    return {
      query,
      asPath,
      item: item.data
    };
  } else {
    if (res) {
      res.writeHead(302, {
        Location: `/halaman-tidak-ditemukan?q=kredit-laptop`
      });
      res.end();
    }
    return;
  }
};

export default kreditLaptop;
